/**
 * Shared FancyApps Fancybox initialization (CDN UMD global).
 * Used by gallery and image block view scripts.
 *
 * @param {string} selector CSS selector for anchor elements to bind
 * @param {Object} [options] Optional Fancybox options merged over defaults
 */
export function initFancybox(selector, options = {}) {
  const { Fancybox } = window;
  if (!Fancybox) {
    return;
  }

  const defaults = {
    groupAll: false,
    groupAttr: 'data-fancybox',
    Toolbar: {
      display: {
        left: ['infobar'],
        middle: [],
        right: ['slideshow', 'download', 'thumbs', 'close'],
      },
    },
    on: {
      reveal: (fancybox, slide) => {
        if (slide.$trigger) {
          const caption =
            slide.$trigger.dataset.caption || slide.$trigger.dataset.title || '';
          if (caption) {
            slide.caption = caption;
          }
        }
      },
    },
  };

  const merged = {
    ...defaults,
    ...options,
    on: {
      ...defaults.on,
      ...(options.on || {}),
    },
  };

  Fancybox.bind(selector, merged);
}

/**
 * Tear down a Fancybox binding installed by `initFancybox`. Call from a
 * block view script's destroy() handler so soft-navigation does not leave
 * orphaned bindings or open lightboxes.
 *
 * @param {string} selector CSS selector previously passed to initFancybox
 */
export function destroyFancybox(selector) {
  const { Fancybox } = window;
  if (!Fancybox) return;

  try {
    if (typeof Fancybox.close === 'function') {
      Fancybox.close();
    }
  } catch (e) { /* ignore */ }

  try {
    if (typeof Fancybox.unbind === 'function') {
      Fancybox.unbind(selector);
    }
  } catch (e) { /* ignore */ }
}
